import React, { useEffect } from 'react'
import UserAgentParser from 'ua-parser-js'
import './OldBrowserNotice.scss'
import useIsMobile from 'context/IsMobileContext'

var languageMessages = require('./browser_detect_languages.json')

function OldBrowserNotice() {
    const { isMobileApp } = useIsMobile()

    useEffect(() => {
        var DEFAULTS = {
            Chrome: 57, // Includes Chrome for mobile devices
            Edge: 39,
            Safari: 10,
            'Mobile Safari': 10,
            Firefox: 50,
            IE: false,
        }

        var EDGEHTML_VS_EDGE_VERSIONS = {
            12: 0.1,
            13: 21,
            14: 31,
            15: 39,
            16: 41,
        }
        // Despite the docs, UA needs to be provided to constructor explicitly:
        // https://github.com/faisalman/ua-parser-js/issues/90
        var parsedUserAgent = new UserAgentParser(window.navigator.userAgent).getResult()

        // Variable definition (before ajax)
        var outdatedUI = document.getElementById('outdated')

        // *** LIST OF BROWSER UAs FOR OPTIONS OBJECT BELOW ***
        // https://github.com/faisalman/ua-parser-js/blob/82aba654f970cf4bcce0631cd8185dddf6179225/test/browser-test.json
        // Versions based off of flexbox compatability - https://caniuse.com/#feat=flexbox

        var options = {
            browserSupport: {
                Chrome: 57, // Includes Chrome for mobile devices
                Edge: 39,
                Safari: 10,
                'Android Browser': 4,
                IEMobile: 11,
                UCBrowser: 5,
                'Opera Mobi': 37,
                'Mobile Safari': 10,
                Firefox: 50,
                IE: 11,
                Opera: 17,
                'Opera Mini': 0, // all versions work
                Facebook: 0, // all versions work
                'Chrome Webview': 64,
            },
            requireChromeOnAndroid: true,
            backgroundColor: '#156BAC',
        }

        // Set default options
        var browserSupport = options.browserSupport || DEFAULTS
        // CSS property to check for. You may also like 'borderSpacing', 'boxShadow', 'transform', 'borderImage';
        var requiredCssProperty = options.requiredCssProperty || false
        var backgroundColor = options.backgroundColor || '#f25648' // Salmon
        var textColor = options.textColor || 'white'
        var language = 'en' // Language code

        var updateSource = 'web' // Other possible values are 'googlePlay' or 'appStore'. Determines where we tell users to go for upgrades.

        // Chrome mobile is still Chrome (unlike Safari which is 'Mobile Safari')
        var isAndroid = parsedUserAgent.os.name === 'Android'
        if (isAndroid) {
            updateSource = 'googlePlay'
        }

        var isAndroidButNotChrome
        if (options.requireChromeOnAndroid) {
            isAndroidButNotChrome = isAndroid && parsedUserAgent.browser.name !== 'Chrome'
        }

        if (parsedUserAgent.os.name === 'iOS') {
            updateSource = 'appStore'
        }

        var done = true

        var changeOpacity = function(opacityValue) {
            outdatedUI.style.opacity = opacityValue / 100
            outdatedUI.style.filter = 'alpha(opacity=' + opacityValue + ')'
        }

        var fadeIn = function(opacityValue) {
            changeOpacity(opacityValue)
            if (opacityValue === 1) {
                outdatedUI.style.display = 'block'
            }
            if (opacityValue === 100) {
                done = true
            }
        }

        var isBrowserOutOfDate = function() {
            var browserName = parsedUserAgent.browser.name
            var browserMajorVersion = parsedUserAgent.browser.major
            if (browserName === 'Edge') {
                browserMajorVersion = EDGEHTML_VS_EDGE_VERSIONS[browserMajorVersion]
            }
            var isOutOfDate = false
            if (!browserSupport[browserName]) {
                isOutOfDate = true
            } else if (browserMajorVersion < browserSupport[browserName]) {
                isOutOfDate = true
            }
            return isOutOfDate
        }

        // Returns true if a browser supports a css3 property
        var isPropertySupported = function(prop) {
            if (!prop) {
                return true
            }
            var div = document.createElement('div')
            var vendorPrefixes = ['khtml', 'ms', 'o', 'moz', 'webkit']
            var count = vendorPrefixes.length

            if (div.style[prop]) {
                return true
            }

            prop = prop.replace(/^[a-z]/, function(val) {
                return val.toUpperCase()
            })

            while (count--) {
                if (div.style[vendorPrefixes[count] + prop]) {
                    return true
                }
            }
            return false
        }

        var makeFadeInFunction = function(opacityValue) {
            return function() {
                fadeIn(opacityValue)
            }
        }

        // Style element explicitly - TODO: investigate and delete if not needed
        var startStylesAndEvents = function() {
            var buttonClose = document.getElementById('buttonCloseUpdateBrowser')
            var buttonUpdate = document.getElementById('buttonUpdateBrowser')

            //check settings attributes
            outdatedUI.style.backgroundColor = backgroundColor
            //way too hard to put !important on IE6
            outdatedUI.style.color = textColor
            outdatedUI.children[0].style.color = textColor
            outdatedUI.children[1].style.color = textColor

            // Update button is desktop only
            if (buttonUpdate) {
                buttonUpdate.style.color = textColor
                if (buttonUpdate.style.borderColor) {
                    buttonUpdate.style.borderColor = textColor
                }

                // Override the update button color to match the background color
                buttonUpdate.onmouseover = function() {
                    this.style.color = backgroundColor
                    this.style.backgroundColor = textColor
                }

                buttonUpdate.onmouseout = function() {
                    this.style.color = textColor
                    this.style.backgroundColor = backgroundColor
                }
            }

            buttonClose.style.color = textColor

            buttonClose.onmousedown = function() {
                outdatedUI.style.display = 'none'
                return false
            }
        }

        var getmessage = function(lang) {
            var messages = languageMessages[lang] || languageMessages.en

            var updateMessages = {
                web:
                    '<p>' +
                    messages.update.web +
                    '<a id="buttonUpdateBrowser" href="' +
                    messages.url +
                    '">' +
                    messages.callToAction +
                    '</a></p>',
                googlePlay:
                    '<p>' +
                    messages.update.googlePlay +
                    '<a id="buttonUpdateBrowser" href="https://play.google.com/store/apps/details?id=com.android.chrome">' +
                    messages.callToAction +
                    '</a></p>',
                appStore: '<p>' + messages.update[updateSource] + '</p>',
            }

            var updateMessage = updateMessages[updateSource]

            return (
                '<h6>' +
                messages.outOfDate +
                '</h6>' +
                updateMessage +
                '<p class="last"><a href="#" id="buttonCloseUpdateBrowser" title="' +
                messages.close +
                '">×</a></p>'
            )
        }

        // Check if browser is supported
        if (
            !isMobileApp &&
            (isBrowserOutOfDate() ||
                !isPropertySupported(requiredCssProperty) ||
                isAndroidButNotChrome)
        ) {
            // This is an outdated browser
            if (done && outdatedUI.style.opacity !== '1') {
                done = false

                for (var opacity = 1; opacity <= 100; opacity++) {
                    setTimeout(makeFadeInFunction(opacity), opacity * 8)
                }
            }

            var insertContentHere = document.getElementById('outdated')
            insertContentHere.innerHTML = getmessage(language)
            startStylesAndEvents()
        }
    }, [])
    return (
        <div id="outdated" /> // Outdated browser root.
    )
}

export default OldBrowserNotice
